import {
  sms_check_confirmation_path
} from '~/routes';

var init = function() {
		$('#modal-dialog').off('modal:loaded');
		$('#modal-dialog').on('modal:loaded', function() {
			$('#sms-confirmation-cancel').on('click', function() {
				$('.modal').modal('hide');
				return false;
			});

			var resendTimer = setTimeout(function() {
				$('#sms-confirmation-resend').show();
			}, 60*1000);

			$('#sms-confirmation-submit').on('click', function() {
				$.post(sms_check_confirmation_path({
					confirmation_code: $('#sms-confirmation-input').val(),
					identifier: $('#sms-confirmation-identifier').val()
				}))
				.done(function(data) {
					if (data.status == 'valid') {
						$(document).trigger('sms:success', [$('#sms-confirmation-type').val(), $('#sms-confirmation-identifier').val()]);
					}
					else {
						$('#sms-confirmation-error').show();
						$('#sms-confirmation-submit').removeClass('disabled').prop('disabled', false).text(I18n.t('proceed'));
						$(document).trigger('sms:failed', [$('#sms-confirmation-type').val(), $('#sms-confirmation-identifier').val()]);
					}
				});

				return false;
			});

			$(document).trigger('sms:opened', [$('#sms-confirmation-type').val(), $('#sms-confirmation-identifier').val()]);

			$('#sms-confirmation-input').on('keyup', function(e) {
				if ($(this).val().length == 6) {
					$('#sms-confirmation-submit').prop('disabled', false);
				}
				else {
					$('#sms-confirmation-submit').prop('disabled', true);
				}
			});

			$('#sms-confirmation-resend-button').on('click', function() {
				$('#modal-dialog .modal-body').load(sms_new_confirmation_path({format: null, type: $('#sms-confirmation-type').val()}), function() {
          $('#modal-dialog').trigger('modal:loaded');
				});
				return false;
			});
		});
	}

window.initSMSConfirmation = init;